import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";

const PageTitle: React.FC = ({ children }) => {
  return <StyledTitleWrapper>{children}</StyledTitleWrapper>;
};
const StyledTitleWrapper = styled.div`
  ${theme.typo.title.t32}
`;
export default PageTitle;
